<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <h3>{{$t('myAccountPc.transactionInquiry')}}</h3>
      </div>
      <el-tabs v-model="activeName" stretch id="tradingQuerytabs">
        <el-tab-pane :label="$t('account.positionInquiry')" name="all_depot">
          <el-table :data="all_depot" stripe size="mini" style="width: 100%">
            <el-table-column prop="name" align="center" :label="$t('stockRise.name')">
            </el-table-column>
            <el-table-column prop="short" align="center" :label="$t('foundWinner.code')">
            </el-table-column>
            <el-table-column prop="number" align="center" :label="$t('positionInquiry.openPositions')">
            </el-table-column>
            <el-table-column prop="surplus" align="center" :label="$t('positionInquiry.availableQuantity')">
            </el-table-column>
            <el-table-column prop="frozen" align="center" :label="$t('positionInquiry.frozenQuantity')">
            </el-table-column>
            <el-table-column prop="newPrice" align="center" :label="$t('positionInquiry.currentPrice')">
            </el-table-column>
            <el-table-column prop="price" align="center" :label="$t('positionInquiry.costPrice')">
            </el-table-column>
            <el-table-column prop="profitPrice" align="center" :label="$t('tradingquery.profitLossAmount')">
            </el-table-column>
            <el-table-column prop="priceRatio" align="center" :label="$t('tradingquery.profitLossRatio')">
              <template slot-scope="scope">
                <p>{{ scope.row.priceRatio }}%</p>
              </template>
            </el-table-column>
            <el-table-column prop="market" align="center" :label="$t('trading.marketValue')">
            </el-table-column>
            <el-table-column prop="time" align="center" :label="$t('positionInquiry.openingDate')">
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('account.cancellationInquiry')" name="all_cancel">
          <el-table :data="all_cancel" size="mini" stripe style="width: 100%">
            <el-table-column prop="name" align="center" :label="$t('stockRise.name')">
            </el-table-column>
            <el-table-column prop="short" align="center" :label="$t('foundWinner.code')">
            </el-table-column>
            <el-table-column prop="type" align="center" :label="$t('withdrawInquiry.CommissionDirection')">
            </el-table-column>
            <el-table-column prop="deal" align="center" :label="$t('withdrawInquiry.CommissionPrice')">
              <template slot-scope="scope">
                <p>{{ scope.row.deal.toFixed(2) }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="number" align="center" :label="$t('withdrawInquiry.OrderQuantity')">
            </el-table-column>
            <el-table-column prop="surplus" align="center" :label="$t('withdrawInquiry.unsoldQuantity')">
            </el-table-column>
            <el-table-column prop="status" align="center" :label="$t('withdrawInquiry.commissionStatus')">
            </el-table-column>
            <el-table-column prop="time" align="center" :label="$t('withdrawInquiry.commissionTime')">
            </el-table-column>
            <el-table-column :label="$t('stock.operate')" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)"
                  >{{$t('stock.cancelation')}}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('entrustInquiry.title')" name="entrust">
          <el-form :inline="true" size="mini">
            <el-form-item :label="$t('dealInquiry.commissionDate')" id="inputField">
              <el-date-picker
                v-model="entrustData.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                :range-separator="$t('financefund.to')"
                :start-placeholder="$t('financefund.startDate')"
                :end-placeholder="$t('financefund.endDate')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)" @click="getEntrust">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="entrustData.entrust"
            size="mini"
            stripe
            style="width: 100%"
          >
            <el-table-column prop="name" align="center" :label="$t('stockRise.name')">
            </el-table-column>
            <el-table-column prop="short" align="center" :label="$t('foundWinner.code')">
            </el-table-column>
            <el-table-column prop="deal" align="center" :label="$t('withdrawInquiry.CommissionPrice')">
            </el-table-column>
            <el-table-column prop="price" align="center" :label="$t('entrustInquiry.dealPrice')">
            </el-table-column>
            <el-table-column prop="number" align="center" :label="$t('withdrawInquiry.OrderQuantity')">
            </el-table-column>
            <el-table-column prop="finish" align="center" :label="$t('entrustInquiry.transactionCount')">
            </el-table-column>
            <el-table-column prop="type" align="center" :label="$t('entrustInquiry.buySell')">
            </el-table-column>
            <el-table-column prop="status" align="center" :label="$t('entrustInquiry.state')">
            </el-table-column>
            <el-table-column
              prop="accurate"
              align="center"
              width="150"
              :label="$t('withdrawInquiry.commissionTime')"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.time }} {{ scope.row.accurate }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="complete_time"
              align="center"
              width="150"
              :label="$t('dealInquiry.transactionTime')"
            >
            </el-table-column>
          </el-table>
          <div class="changePage">
            <el-button
              type="primary"
              style="background-color: var(--baseColor);border-color:var(--baseColor)"
              icon="el-icon-arrow-left"
              @click="prevEntrust"
              size="mini"
              >{{ $t('timeBao.previous') }}</el-button
            >
            <el-button
              type="primary"
              style="float: right;background-color: var(--baseColor);border-color:var(--baseColor)"
              @click="nextEntrust"
              size="mini"
              >{{ $t('timeBao.next') }}
              <i class="el-icon-arrow-right"></i></el-button
            >
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('account.transactionInquiry')" name="deal">
          <el-form :inline="true" size="mini">
            <el-form-item :label="$t('entrustInquiry.commissionedDate')" id="inputField">
              <el-date-picker
                v-model="dealData.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                cellClassName="date"
                :range-separator="$t('financefund.to')"
                :start-placeholder="$t('financefund.startDate')"
                :end-placeholder="$t('financefund.endDate')"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)"
               @click="getDeal">{{$t('stock.inquire')}}</el-button>
            </el-form-item>
            <el-form-item> {{$t('tradingquery.buyAmount')}} {{ totalbuy.toFixed(2) }} </el-form-item>
            <el-form-item> {{$t('tradingquery.sellingAmount')}} {{ totalsell.toFixed(2) }} </el-form-item>
          </el-form>
          <el-table
            :data="dealData.deal"
            size="mini"
            stripe
            style="width: 100%"
          >
            <el-table-column prop="name" align="center" :label="$t('stockRise.name')">
            </el-table-column>
            <el-table-column prop="code" align="center" :label="$t('foundWinner.code')">
            </el-table-column>
            <el-table-column prop="type" align="center" :label="$t('dealInquiry.transactionDirection')">
            </el-table-column>
            <el-table-column prop="price" align="center" :label="$t('entrustInquiry.dealPrice')">
            </el-table-column>
            <el-table-column prop="number" align="center" :label="$t('entrustInquiry.transactionCount')">
            </el-table-column>
            <el-table-column prop="total" align="center" :label="$t('trading.turnover')">
            </el-table-column>
            <el-table-column prop="commission" align="center" :label="$t('dealInquiry.brokerageCommission')">
            </el-table-column>
            <!-- <el-table-column prop="stamp" align="center" :label="$t('dealInquiry.stampDuty')">
            </el-table-column> -->
            <!-- <el-table-column prop="change" align="center" :label="$t('dealInquiry.transferFee')">
            </el-table-column> -->
            <!-- <el-table-column
              prop="extra_fee1"
              align="center"
              :label="$t('dealInquiry.productHandlingFee')"
            >
            </el-table-column> -->
            <!-- <el-table-column prop="extra_fee2" align="center" :label="$t('dealInquiry.settlementFee')">
            </el-table-column> -->
            <!-- <el-table-column prop="extra_fee3" align="center" :label="$t('dealInquiry.platformFee')">
            </el-table-column> -->
            <el-table-column
              prop="time"
              align="center"
              :label="$t('dealInquiry.transactionTime')"
              width="100"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.time }}</p>
                <p>{{ scope.row.accurate }}</p>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('stock.sysClose')" name="unwind">
          <el-table :data="unwindData" size="mini" stripe style="width: 100%">
            <el-table-column prop="name" align="center" :label="$t('stockRise.name')">
            </el-table-column>
            <el-table-column prop="code" align="center" :label="$t('foundWinner.code')">
            </el-table-column>
            <el-table-column prop="type" align="center" :label="$t('dealInquiry.transactionDirection')">
            </el-table-column>
            <el-table-column prop="number" align="center" :label="$t('entrustInquiry.transactionCount')">
            </el-table-column>
            <el-table-column prop="price" align="center" :label="$t('entrustInquiry.dealPrice')">
            </el-table-column>
            <el-table-column prop="total" align="center" :label="$t('trading.turnover')">
            </el-table-column>
            <el-table-column prop="commission" align="center" :label="$t('dealInquiry.brokerageCommission')">
            </el-table-column>
            <el-table-column prop="stamp" align="center" :label="$t('dealInquiry.stampDuty')">
            </el-table-column>
            <el-table-column prop="change" align="center" :label="$t('dealInquiry.transferFee')">
            </el-table-column>
            <el-table-column prop="time" align="center" :label="$t('dealInquiry.transactionTime')">
              <template slot-scope="scope">
                <p>{{ scope.row.time }}</p>
                <p>{{ scope.row.accurate }}</p>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
    import $ from "jquery";

    export default {
      name: "tradingQuery",
      data(){
        return{
          activeName:'all_depot',
          all_depot:[],
          all_cancel:[],
          entrustData:{
            date:[],
            entrust:[],
            page:1,
            num:20,
          },
          dealData:{
            date:[],
            deal:[],
          },
          unwindData:[],
          totalbuy:0,
          totalsell:0
        }
      },
      methods:{
        getAllDepot() {
          let that = this;
          that.$http({
              url: "/app/Depot/all_depots",
              method: "post",
              data: {
                
              },
              transformRequest: [(data) => JSON.stringify(data)]
            })
            .then(function(res) {
              let resData = res.data;
              if (resData.status == 200) {
                let dataArr = resData.data;
                if (dataArr.length != 0){
                  let shortArr = [];
                  $.each(dataArr, function(index, item) {
                    shortArr.push(item.short);
                  });
                  that.getNewPrice(shortArr,dataArr);
                }else{
                  that.all_depot = resData.data;
                }
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        getAllCancel(){
          let that = this;
          that.$http({
            url: "/app/Entrust/all_cancel",
            method: "post",
            data: {
              
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
            .then(function(res) {
              let resData = res.data;
              if (resData.status == 200) {
                that.all_cancel = resData.data;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        getEntrust(){
          let that = this;
          that.$http({
            url: "/app/Entrust/all_entrust",
            method: "post",
            data: {
             
              start:that.entrustData.date[0],
              end:that.entrustData.date[1],
              page:that.entrustData.page,
              num:that.entrustData.num,
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
            .then(function(res) {
              let resData = res.data;
              if (resData.status == 200) {
                let entrust = resData.data;
                let unwindData = [];
                for (let i = 0,len = entrust.length;i < len; i++){
                  if (entrust[i].depot_mold === 1){
                    unwindData.push(entrust[i])

                  }
                }
                that.unwindData = unwindData;
                that.entrustData.entrust = entrust;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        getUnwindData(){
          let that = this;
          that.$http({
            url: "/app/Deal/all_deals",
            method: "post",
            data: {
              
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
            .then(function(res) {
              let resData = res.data;
              if (resData.status == 200) {
                let entrust = resData.data;
                let unwindData = [];
                for (let i = 0,len = entrust.length;i < len; i++){
                  if (entrust[i].depot_mold === 1){
                    unwindData.push(entrust[i])
                    that.totalbuy = that.totalbuy + parseFloat(entrust[i].total)
                  }else{
                    that.totalsell = that.totalsell + parseFloat(entrust[i].total)
                  }
                }
                that.unwindData = unwindData;
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });

        },
        getDeal(){
          let that = this;
          that.$http({
            url: "/app/Deal/all_deals",
            method: "post",
            data: {
              
              start:that.dealData.date[0],
              end:that.dealData.date[1],
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
            .then(function(res) {
              let resData = res.data;
              if (resData.status == 200) {
                that.dealData.deal = resData.data;

                that.totalbuy = 0;
                that.totalsell = 0;

                let entrust = resData.data;
                for (let i = 0,len = entrust.length;i < len; i++){
                  
                  if (entrust[i].isBuy === 1){
                    that.totalbuy = that.totalbuy + parseFloat(entrust[i].total)
                  }else{
                    that.totalsell = that.totalsell + parseFloat(entrust[i].total)
                  }
                }

                
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        prevEntrust(){
          let page = this.entrustData.page;
          if (page == 1){
            this.$message({
              message: this.$t('timeBao.alreadyFirstPage'),
              type: 'warning'
            });
          }else{
            this.entrustData.page = page-1;
            this.getEntrust();
          }
        },
        nextEntrust(){
          let page = this.entrustData.page;
          if ( this.entrustData.entrust.length < 20){
            this.$message({
              message: this.$t('timeBao.alreadyLastPage'),
              type: 'warning'
            });
          }else{
            this.entrustData.page = page+1;
            this.getEntrust();
          }
        },
        handleDelete(data){
          let that = this;
          that.$http({
            url: "/app/Entrust/cancel_entrust",
            method: "post",
            data: {
              cid: data.cid,
              order: data.id
            },
            transformRequest: [(data) => JSON.stringify(data)]
          })
            .then(function(res) {
              // response data status need to check
              if (res.data.status == 200) {
                that.$message({
                  message: that.$t(res.data.msgId),
                  type: "success",
                  duration: 1000,
                  onClose:function () {
                    that.getAllCancel();
                  }
                });
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }
            });
        },
        getNewPrice(shortArr, dataArr) {
          let that = this;
          $.ajax({
            url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
            type: "GET",
            dataType: "script",
            cache: true,
            success: function() {
              var i, elements;
              for (i = 0; i < shortArr.length; i++) {
                var elements = eval("v_" + shortArr[i]).split("~");
                dataArr[i]["newPrice"] = elements[3]; //当前价
                var newPrice = parseFloat(elements[3]); //当前价
                var number = parseFloat(dataArr[i].number); //持有股数
                var costPrice = parseFloat(dataArr[i].price); //成本价
                var profitPrice = Number((newPrice - costPrice).toFixed(2)); //盈亏金额
                var priceRatio = ((newPrice - costPrice) / costPrice) * 100; //盈亏比例
                var market = (newPrice * number).toFixed(2); //当前市值
                priceRatio = priceRatio.toFixed(2);
                dataArr[i]["profitPrice"] = profitPrice;
                dataArr[i]["priceRatio"] = priceRatio;
                dataArr[i]["market"] = market;
              }
              that.all_depot = dataArr
            }
          });
        },
      },
      mounted(){
        this.getAllDepot();
        this.getAllCancel();
        this.getUnwindData();
        this.getDeal();
        this.getEntrust();
      },

    }
</script>

<style scoped>
.changePage {
  margin-top: 10px;
}
.box-card {
  border-radius: 8px;
  border: none;
  background-color: #f4f4f8;
}

.box-card >>> .el-card__header {
  background-color: #ffffff;
  border-radius: 8px;
  border: none;
  margin-bottom: 20px;
}

.box-card >>> .el-card__body {
  background-color: #ffffff;
  border-radius: 8px;
  border: none;
}
.title {
  font-weight: 700;
}
#inputField>>>.el-input__inner:focus {
  border-color: var(--baseColor) !important;
}
#inputField>>>.el-input__inner:hover {
  border-color: var(--baseColor) !important;
}
#inputField>>>.el-input__inner:active {
  border-color: var(--baseColor) !important;
}
#inputField>>>.el-range-editor.is-active {
  border-color: var(--baseColor) !important;
  
}
</style>

<style>
#tradingQuerytabs .el-tabs__active-bar {
  display: none;
  background-color: var(--baseColor);
}

#tradingQuerytabs .el-tabs__item.is-active {
  color: var(--baseColor);
}
#tradingQuerytabs .el-tabs__item:hover {
  color: var(--baseColor) !important;
}

#tradingQuerytabs .el-tabs__item.is-active:after {
  height: 6px;
  display: block;
  width: auto;
  background: var(--baseColor);
  content: "";
  border-radius: 5px;
  width: 45px;
  display: block;
  margin: 0 auto;
  top: -6px;
  position: relative;
}
</style>
<style>
.el-date-table td.today span {
  color: var(--baseColor) !important;
}
.el-date-table td.today.start-date span{
  color: #fff !important;
}

.el-date-table td.end-date span, .el-date-table td.start-date span {
  background-color: var(--baseColor) !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tradingQuery.vue